import { type ChangeEvent, useId } from "react";
import styled from "styled-components";
import { border } from "../constants/styles";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  color: ${(props) => props.theme.colors.main};
  margin-bottom: 4px;
`;

const StyledInput = styled.input`
  ${border}
  padding: 12px 8px;
  font-family: inherit;
  background-color: ${(props) => props.theme.colors.mainSurface};
  color: ${(props) => props.theme.colors.main};
`;

const Hint = styled.span`
  margin-top: 4px;
  font-size: 12px;
  color: ${(props) => props.theme.colors.secondary};
`;

interface Props {
  label: string;
  hint?: string;
  placeholder?: string;
  value?: string | number;
  onChange: (value: string) => void;
}

export const TextInput = ({
  label,
  hint,
  placeholder,
  value,
  onChange,
}: Props) => {
  const id = useId();

  return (
    <Wrapper>
      <Label htmlFor={id}>{label}</Label>
      <StyledInput
        id={id}
        placeholder={placeholder}
        value={value}
        aria-describedby={hint ? `${id}-hint` : undefined}
        onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
          onChange(target.value)
        }
      />
      {hint && <Hint id={`${id}-hint`}>{hint}</Hint>}
    </Wrapper>
  );
};
